import { render, staticRenderFns } from "./suporte-feedback.vue?vue&type=template&id=110a526d&scoped=true"
import script from "./suporte-feedback.vue?vue&type=script&lang=ts"
export * from "./suporte-feedback.vue?vue&type=script&lang=ts"
import style0 from "./suporte-feedback.vue?vue&type=style&index=0&id=110a526d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110a526d",
  null
  
)

export default component.exports